export const ANALYTICS_TYPE = 'private'
export const CALL_COST_IN_COINS = 120
export const LOW_COINS = 600
